module.exports = __webpack_public_path__ + "img/home_btn.f717c0c0.png";